import { useBreakpointValue } from "@chakra-ui/react"
import { useBrandedTranslation } from "../../../../common/hooks/useBrandedTranslation"
import { useGigya } from "../../../../common/hooks/useGigya"
import { ChakraNextLinkButton } from "../../../shared/ChakraNextLinkButton"
import { CLogout } from "../../../shared/Icons"

type Props = {
  isMenu?: boolean
  handler?: () => void
}

const LogoutButton = ({ isMenu = false, handler }: Props) => {
  const { t } = useBrandedTranslation()
  const { logout } = useGigya()

  const buttonLabel = useBreakpointValue({
    base: isMenu ? t("header-logged-logOut") : "",
    sm: t("header-logged-logOut"),
  })

  const handleLogout = async () => {
    /* Optional additional handler to do something on logout */
    if (handler) handler()
    /* Trigger Gigya logout functionality */
    await logout()

    /* Global state and cookie are cleared in the event handler for the global onLogout
      event fired by Gigya, onLogoutCallback */
  }

  return (
    <ChakraNextLinkButton
      href="/"
      variant={isMenu ? "mobileMenu" : "secondary"}
      aria-label="Logout"
      leftIcon={<CLogout transform="rotate(180deg)" />}
      label={buttonLabel}
      color="black"
      border={isMenu ? "none" : "1px solid"}
      iconSpacing={isMenu ? "3" : { base: "0", sm: "2.5" }}
      onClick={handleLogout}
    />
  )
}

export default LogoutButton
